module.exports = __webpack_public_path__ + "static/media/b0_p13_melody.c56971ef.mp3";